export const CHECK_CONNECTION_INTERVAL_MS = 5000;
